import React from "react";

type Props = {
    columns: { name: string; title: string; }[],
    selected: { name: string; title: string; }[],
    onDoubleClick: Function,
    onSelect: Function,
    isMouseDown: boolean,
    onMouseUp: React.MouseEventHandler<HTMLDivElement>,
    onMouseDown: Function,
    onMouseOver: Function,
    onMouseEnter: React.MouseEventHandler<HTMLDivElement>
}

const MultiSelectList = (props: Props) => {
    const isSelected = (item: { name: string; title: string; }) => {
        return props.selected.length > 0 && props.selected.indexOf(item) !== -1;
    };
    
    return (
        <div className="config-item__multiselect-list" onMouseEnter={props.onMouseEnter} onMouseUp={props.onMouseUp}>
            {
                props.columns.map((column, index) => (
                    <div
                        className={`config-item__multiselect-list-item ${isSelected(column) ? "selected" : ""}`}
                        key={column.name}
                        onClick={(e) => { props.onSelect(column, e);}}
                        onDoubleClick={ () => props.onDoubleClick(column) }
                        onMouseDown={(e) => props.onMouseDown(e, column, index)}
                        onMouseOver={() => { if (props.isMouseDown) {props.onMouseOver(column, index);}}}
                    >
                        {column.title}
                    </div>

                ))
            }
        </div>
    );
};

export default MultiSelectList;
